import React from "react";

import { Table } from "../../../../../../../../Components/FinalTable";

import THead from "./THead";

import TBody from "./TBody";

const TableAll = () => {
  return (
    <Table>
      <THead />
      <TBody />
    </Table>
  );
};

export default TableAll;
